import React, { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

import Typography from 'components-new/typography/typography';

import { createLocale } from 'locales';

import VideoPreview from 'components/video-preview';

import {
  STATIC_FILES_URL,
  TADAAH_HOME_MARKETING,
} from 'constants/signup-flow-constants';

import FreelancerSignUpPageContainer from '../components/freelancer-sign-up-page-container';

import DialogInstructionsContent from './DialogInstructionsContent';

const localize = createLocale('freelancerSubmitApplicationPageLocales');

const url = `${STATIC_FILES_URL}videos/signupflow/h9.mp4`;
const videoPreviewImageURL = `${window.STATIC_URL}assets/signupflow/h9.png`;

const SubmitApplication: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openInstructionsDialog = useCallback(() => {
    setSearchParams({
      shouldInstructionsDialog: 'true',
    });
  }, [setSearchParams]);

  const closeInstructionsDialog = useCallback(() => {
    setSearchParams({
      shouldInstructionsDialog: 'false',
    });
  }, [setSearchParams]);

  return (
    <FreelancerSignUpPageContainer headerTitle={localize('title')} showHeader>
      <Typography
        as="p"
        variant="body-medium"
        className="text-gray500 w-full m-4"
      >
        {localize('headline')}
      </Typography>
      <Typography
        as="p"
        variant="body-medium-bold"
        className="block text-purple w-full my-3 text-center text-sm"
      >
        <a href={TADAAH_HOME_MARKETING} target="blank">
          {localize('learnMore')}
        </a>
      </Typography>
      <VideoPreview
        videoPreviewImageURL={videoPreviewImageURL}
        videoURL={url}
      />
      <Typography
        as="p"
        variant="body-medium"
        className="mt-4 text-gray500 whitespace-pre-line text-center"
      >
        {localize('readInstructions')}{' '}
        <button
          type="button"
          className="text-body-medium-bold font-bold text-purple whitespace-pre-line cursor-pointer"
          onClick={openInstructionsDialog}
        >
          {localize('clickHere')}
        </button>
      </Typography>
      <DialogInstructionsContent
        isOpen={searchParams.get('shouldInstructionsDialog') === 'true'}
        onCloseClicked={closeInstructionsDialog}
      />
    </FreelancerSignUpPageContainer>
  );
};

export default SubmitApplication;
